<template>
    <div class="tab_bar degree-detail-tab" :class="setTabFixed ? 'fixed-top' : ''">
        <div class="mdc-tab-bar view-tab-bar" role="tablist" ref="degreeViewTab">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('ViewCourse')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('607')}}
                                    <!-- 과정개요 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="1" @click="changeTabType('ViewLesson')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('608')}}
                                    <!-- 레슨 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="2" @click="changeTabType('ViewReward')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('609')}}
                                    <!-- 리워드 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>

                        <button class="mdc-tab" role="tab" tabindex="3" @click="changeTabType('ViewCertification')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('610')}}
                                    <!-- 증명서 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 차수 상세 탭 컴포넌트(degree view tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    props: ['setTabFixed'],
    data() {
        return {
            degreeViewTab: null,
            tabType: 'ViewCourse',
        }
    },

    mounted() {
        this.degreeViewTab = new MDCTabBar(this.$refs.degreeViewTab)
    },

    updated() {
        this.degreeViewTab = new MDCTabBar(this.$refs.degreeViewTab)

        if (this.tabType === 'ViewCourse') {
            this.degreeViewTab.activateTab(0)
        }else if (this.tabType === 'ViewLesson') {
            this.degreeViewTab.activateTab(1)
        }else if (this.tabType === 'ViewReward') {
            this.degreeViewTab.activateTab(2)
        }else if (this.tabType === 'ViewCertification') {
            this.degreeViewTab.activateTab(3)
        }else {
            this.degreeViewTab.activateTab(0)
        }
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            this.tabType = type
            this.$emit('setSubTab', type)
        }
        
    }
}
</script>
